import {AnyHash, FieldConfig, FieldDataTypes, nNumber, nString, uNumber, Uuid} from "@hidat/huijs-common";
import {RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";
import {ResourceConfig} from "@hidat/huijs-resource";

export const ListItemConfig = new ResourceConfig('ListItem', 'list_items', true, true)
  .addFields([
    RblFieldConfigs.uid,
    RblFieldConfigs.list,
    RblFieldConfigs.libraryTitle,
    new FieldConfig('seqNum', FieldDataTypes.INTEGER),
    new FieldConfig('metaExtended', FieldDataTypes.HASH),
    new FieldConfig('note'),
  ])
  .setSorts({
    createdat: 'createdAt'
  })
  .setDefaultSort('createdat')


export const ListItemApprovalsFields = [
  new FieldConfig('approval_status', FieldDataTypes.INTEGER),
  new FieldConfig('usable'),
  new FieldConfig('note', FieldDataTypes.STRING, true, 'APPROVAL_NOTE'),
  new FieldConfig('review_category'),
  new FieldConfig('review_category2'),
  new FieldConfig('review_site_message')
]
export interface ListItemApprovals {
  usable?: string;
  approval_status?: number;   //depreciated?
  note?: string;
  review_category?: string;
  review_category2?: string;
  review_site_message?: string;
}

// Data Entry/Import fields
export const ListItemContentUpdateFields = [
  new FieldConfig('collection_name'),
  new FieldConfig('release_label_name'),
  new FieldConfig('licensing_label_name'),
  new FieldConfig('publishers'),
  new FieldConfig('publisher_admins'),
  new FieldConfig('pros'),
  new FieldConfig('isrc'),
]
export interface ListItemContentUpdate {
  collection_name?: string;
  release_label_name?: string;
  licensing_label_name?: string;
  publishers?: string;
  publisher_admins?: string;
  pros?: string;
  isrc?: string;
}

export const ListItemSchedulingFields = [
  new FieldConfig('category'),
  new FieldConfig('secondary_category'),
  new FieldConfig('previous_category'),
  new FieldConfig('rotation_status', FieldDataTypes.INTEGER, true, 'TARGET_ROTATION_STATUS'),
  new FieldConfig('start_date'),
  new FieldConfig('name_keyword', FieldDataTypes.STRING, true),
  new FieldConfig('artist_keyword'),
  new FieldConfig('scheduling_notes'),
]
export interface ListItemScheduling {
  category?: string;
  secondary_category?: string;
  previous_category?: string;
  rotation_status?: number;
  start_date?: string;
  name_keyword?: string;
  artist_keyword?: string;
  scheduling_notes?: string;
}

// Dead!
export interface ListItemLyrics {
  tone: string;
  contentRating: number;
}

export const ListItemMetaExtendedFields = [
  new FieldConfig('approvals', FieldDataTypes.HASH),
  new FieldConfig('scheduling', FieldDataTypes.HASH),
  new FieldConfig('licensing', FieldDataTypes.HASH),
  new FieldConfig('lyrics', FieldDataTypes.HASH),
]

export interface ListItemMetaExtended {
  approvals?: ListItemApprovals;
  scheduling?: ListItemScheduling;
  licensing?: ListItemContentUpdate;
  lyrics?: AnyHash;
}
export interface ListItemInterface extends RblTenantResourceInterface {
  uid: Uuid | undefined;
  listId: uNumber;
  seqNum: nNumber;
  libraryTitleId: uNumber;
  metaExtended: ListItemMetaExtended | undefined;
  note: nString;
}
